import React, { useEffect, useState } from "react";
import "./Payment_Summary.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Green_Btn from "../../common_components/common_btn/green_btn/Green_Btn";
import Confirm_Addess_Modal from "../../common_components/common_modal/confirm_addess_modal/Confirm_Addess_Modal";
import { faBuilding, faTags, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Button, Offcanvas } from "react-bootstrap";
import Coupon_Card from "../../common_components/coupon_card/Coupon_Card";
import { useNavigate } from "react-router-dom";
import Gray_Btn from "../../common_components/common_btn/gray_btn/Gray_Btn";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart } from "../../../features/cart/cartSlice";
import {
  CouponApplyed,
  createOrder,
  getAllOrderAddress,
  getAllOrderAddressBilling,
  OrderCalculation,
} from "../../../features/order/orderSlice";
import useRazorpay from "react-razorpay";
import Login_Modal from "../../common_components/common_modal/login_modal/Login_Modal";
import Reset_Password_Modal from "../../common_components/common_modal/reset_password_modal/Reset_Password_Modal";
import Set_New_Password_Modal from "../../common_components/common_modal/set_new_password_modal/Set_New_Password_Modal";
import { getCoupons } from "../../../features/home/homeSlice";
import Success_Modal from "../../common_components/common_modal/success_modal/Success_Modal";
import GST_modal from "../../common_components/common_modal/gst_modal/GST_modal";
import { Spinner } from "react-bootstrap";

const Payment_Summary = ({
  cart,
  data,
  app_setup,
  addressId,
  saveTotal,
  viewAllSummary,
  isCheckoutPage,
  checkout_btn,
  checkoutAction,
  setCouponData,
  CouponData,
  canProceed,
  disable,
  setGSTNumber,
  GSTNumber,
  loading,
  setLoading,
  show,
  refund,
  ...props
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [showOffCanvas, setShowOffCanvas] = useState(false);

  const navigate = useNavigate();
  const [addCartBTNShow, setaddCartBTNShow] = useState(false);

  const isSignIn = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getAllCart(isSignIn));
  // }, []);

  const [showLogoutModal, setshowLogoutModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [email, setEmail] = useState();
  const [contact, setContact] = useState();
  const [isLogedIn, setIsLogedIn] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const allAddress = useSelector((state) => state.order.allOrdersAddress);
  const allBillingAddress = useSelector(
    (state) => state.order.allBillingAddress,
  );

  const user = useSelector((state) => state.myaccount.addMyaccount);
  useEffect(() => {
    // if (user?.id) {
    dispatch(getAllOrderAddress());
    dispatch(getAllOrderAddressBilling());
    // }
  }, []);

  const coupons = useSelector((state) => state.home.addCoupons);

  useEffect(() => {
    dispatch(getCoupons({ amount: data?.total_selling_price }));
  }, [dispatch, data?.total_selling_price]);
  const [showCouponModal, setShowCouponModal] = useState(false);
  // const handelSubmit = (val) => {
  //   setCouponData(val);
  //   setShowCouponModal(true);

  //   setTimeout(() => {
  //     setShowCouponModal(false);
  //   }, 3000);
  //   setShowOffCanvas(false);
  // };

  // const handelSubmit = (val) => {
  //   setCouponData(val);
  //   setShowCouponModal(false);
  //   setTimeout(() => {
  //     setShowCouponModal(true);

  //     setTimeout(() => {
  //       setShowCouponModal(false);
  //     }, 3000);
  //   }, 50);

  //   setShowOffCanvas(false);
  // };

  const [Errors, setErrors] = useState();
  const handelSubmit = async (val) => {
    try {
      const payload = {
        amount: data?.total_selling_price, // here 'data' refers to your prop
        code: val?.code,
      };

      const res = await dispatch(CouponApplyed({ data: payload }));

      if (res.meta?.requestStatus === "fulfilled") {
        setCouponData(val);
        setShowCouponModal(true);
        setShowOffCanvas(false);

        setTimeout(() => {
          setShowCouponModal(false);
        }, 3000);
      } else if (res.meta?.requestStatus === "rejected") {
        setErrors(res?.payload?.errors);
        setShowOffCanvas(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="payment_summary_div">
        {!viewAllSummary && (
          <h3 className="heading">
            <img src="/assets/images/cart/icon.png" className="icon_img" />{" "}
            Payment Summary <span className="inner_text">(incl GST)</span>
          </h3>
        )}

        <div className="summary">
          {/* Total no. of items */}
          <div className="row-divider">
            <div className="title_div">
              <p>Total no. of items</p>
            </div>

            <div className="qty_div">
              <p>{data?.no_of_item || 1} Nos.</p>
            </div>
          </div>

          {/* Payment Mode */}
          {data?.payment_method && (
            <div className="row-divider">
              <div className="title_div">
                <p>Payment Mode</p>
              </div>

              <div className="qty_div">
                <p>{data?.payment_method || data?.Payment_Method?.name} </p>
              </div>
            </div>
          )}

          {/* Taxable value/ Cart value Total */}
          <div className="row-divider">
            <div className="title_div">
              <p>Taxable value/ Cart value</p>
            </div>

            <div className="qty_div">
              <p>₹ {Number(data?.total_selling_price).toFixed(2)}</p>
            </div>
          </div>

          {/* CGST/SGST */}
          <div className="row-divider">
            <div className="title_div">
              {/* <p>{data?.Tax_Type?.name || "CGST/SGST"}</p> */}
              <p>{data?.Tax_Type?.name || "Tax"}</p>
            </div>

            <div className="qty_div">
              <p>
                ₹ {data?.total_tax ? Number(data.total_tax).toFixed(2) : "0.00"}
              </p>
            </div>
          </div>
          {/* Cess Total */}
          <div className="row-divider">
            <div className="title_div">
              <p>Cess Total</p>
            </div>

            <div className="qty_div">
              <p>
                ₹ {Number(data?.total_cess || data?.cess_tax || 0).toFixed(2)}
              </p>
            </div>
          </div>
          {isCheckoutPage && (
            <div className="row-divider">
              <div className="title_div">
                <p>GST Number</p>
              </div>

              <div className="qty_div">
                <Green_Btn
                  onClick={() => setModalShow(true)}
                  btn_name="GST Number"
                />
              </div>
            </div>
          )}

          {/* GST Number */}
          {!show && (
            <>
              {/* Offer Discount */}
              <div className="row-divider">
                <div className="title_div">
                  <p>Offer Discount</p>
                </div>

                <div className="qty_div">
                  <p>
                    ₹{" "}
                    {parseFloat(
                      data?.total_offer_discount || data?.offer_discount || 0,
                    ).toFixed(2)}
                  </p>
                </div>
              </div>

              {/* Coupon Discount */}
              <div className="row-divider">
                <div className="title_div">
                  <p>Coupon Discount</p>
                </div>

                <div className="qty_div">
                  <p>
                    ₹{" "}
                    {data?.total_coupon_discount || data?.coupon_discount || 0}
                  </p>
                </div>
              </div>

              {/* Convenience Fee */}
              <div className="row-divider">
                <div className="title_div">
                  <p>Convenience Fee</p>
                </div>

                <div className="qty_div">
                  <p>
                    ₹{" "}
                    {parseFloat(
                      data?.total_platformCharge || data?.platform_fee || 0,
                    ).toFixed(2)}
                  </p>
                </div>
              </div>

              {/* Delivery */}
              <div className="row-divider">
                <div className="delivery_title_div">
                  <p>
                    Delivery Charges{" "}
                    {parseFloat(data?.total_selling_price) >=
                      parseFloat(app_setup?.minimum_order) && (
                      <span className="inner_title">- Free Delivery</span>
                    )}
                  </p>
                </div>

                <div className="qty_div">
                  <p>
                    ₹{" "}
                    {data?.total_delivery_charges ||
                      data?.delivery_charges ||
                      0}
                  </p>
                </div>
              </div>
            </>
          )}

          {/* Total Save */}
          <div className="row-divider">
            <div className="title_div">
              <p>Total Save</p>
            </div>

            <div className="qty_div">
              <p>
                ₹{" "}
                {(
                  Number(data?.total_mrp_gst ?? 0) -
                  Number(data?.total_selling_price_gst ?? 0) +
                  Number(
                    data?.total_coupon_discount || data?.coupon_discount || 0,
                  ) +
                  Number(
                    data?.total_offer_discount || data?.offer_discount || 0,
                  )
                ).toFixed(2)}
              </p>
            </div>
          </div>

          <div className="total_div">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                <div className="total_title_div">
                  <p>Grand Total</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                <div className="total_qty_div">
                  <p>Rs. {Number(data?.total_amount || 0).toFixed(2)}</p>
                </div>
              </div>
            </div>
          </div>

          {refund && (
            <div className="row-divider">
              <div className="title_div">
                <p>Refund Amount</p>
              </div>

              <div className="qty_div">
                <p>
                  ₹{" "}
                  {Number(data?.Product_Order?.no_of_item) ===
                    Number(data?.Product_Order?.cancel_on_of_item) ||
                  Number(data?.Product_Order?.no_of_item) ===
                    Number(data?.Product_Order?.return_on_of_item)
                    ? (
                        Number(data?.total_amount || 0) -
                        Number(data?.platform_fee || 0)
                      ).toFixed(2)
                    : (
                        Number(data?.total_amount || 0) -
                        (Number(data?.platform_fee || 0) +
                          Number(data?.delivery_charges || 0))
                      ).toFixed(2)}
                </p>
              </div>
            </div>
          )}

          {!isCheckoutPage && (
            <>
              <div className="forgot_div">
                <p className="forgot_text">Forgot Something?</p>
                <div className="add_btn_div">
                  <Green_Btn
                    btn_name="+ Add more items"
                    onClick={() => {
                      navigate("/shop");
                    }}
                  />
                </div>
              </div>

              <div className="checkout_btn">
                {canProceed ? (
                  <>
                    {" "}
                    <Green_Btn
                      btn_name=" Proceed To Checkout"
                      // onClick={() => {
                      //   isSignIn ? setShowModal(true) : setShowLoginModal(true);
                      // }}
                    />
                    {canProceed && (
                      <div
                        style={{
                          color: "red",
                          marginTop: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        {canProceed}
                      </div>
                    )}
                  </>
                ) : (
                  <Green_Btn
                    btn_name="Proceed To Checkout"
                    onClick={() => {
                      isSignIn ? setShowModal(true) : setShowLoginModal(true);
                    }}
                  />
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {isCheckoutPage && (
        <div className="payment_summary_div coupon_main_div">
          <div className="coupon_div">
            <div className="special_div">
              <img
                src="/assets/images/checkout/green_discount.png"
                className="discount_img"
              />
              <p className="special_text">Something Special for you!</p>
            </div>
            <div className="coupons_div">
              <div className="left_side">
                <FontAwesomeIcon icon={faTags} className="tag_icon" />
                <span className="coupon_text">
                  {CouponData?.code || "Coupons"}
                </span>
              </div>
              {CouponData ? (
                <div className="btn_holder">
                  <button
                    className="black_btn"
                    onClick={() => {
                      setCouponData("");
                      // setValue("code", "");
                    }}
                  >
                    Remove
                  </button>
                </div>
              ) : (
                <div className="btn_holder">
                  <button
                    className="black_btn"
                    onClick={() => {
                      setShowOffCanvas(true);
                    }}
                  >
                    View
                  </button>
                </div>
              )}
            </div>
          </div>
          {Errors && (
            <p style={{ color: "red", marginTop: "8px", fontSize: "14px" }}>
              {Errors}
            </p>
          )}
          <div className="checkout_btn">
            <Green_Btn
              btn_name={
                loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Processing...
                  </>
                ) : (
                  checkout_btn
                )
              }
              onClick={!loading ? checkoutAction : undefined} // prevent click when loading
              disabled={loading} // also disable button
            />
          </div>

          {/* <div className="checkout_btn">
            <Green_Btn btn_name={checkout_btn} onClick={checkoutAction} />
          </div> */}
        </div>
      )}
      {/* 
            <Confirm_Addess_Modal
                show={showModal}
                onHide={() => { setShowModal(false) }}
            /> */}

      <Offcanvas
        className="right_bottom_offcanvas"
        placement="bottom"
        show={showOffCanvas}
        onHide={() => {
          setShowOffCanvas(false);
        }}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <FontAwesomeIcon icon={faTags} className="tag_icon" /> Coupons
          </Offcanvas.Title>
          <div
            className="icon_holder"
            onClick={() => {
              setShowOffCanvas(false);
            }}
          >
            <FontAwesomeIcon icon={faXmark} className="close_icon" />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="coupon_cards_div">
            {/* <Coupon_Card showtc /> */}
            {coupons?.data?.length <= 0 && "Coupon Not available"}
            {coupons?.data?.map((val) => (
              <Coupon_Card val={val} data={data} handelSubmit={handelSubmit} />
            ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        className="right_bottom_offcanvas confirm_delivery_address_offcanvas"
        placement="bottom"
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Offcanvas.Body>
          <div className="Confirm_Addess_Modal">
            <div className="modal-content">
              <div className="modal-header">
                <div className="title_text">
                  <p>Confirm Delivery Address</p>
                </div>

                <div className="right_side">
                  <img
                    src="/assets/images/cart/close.png"
                    className="close_img"
                    onClick={() => {
                      setShowModal(false);
                    }}
                  />
                </div>
              </div>

              <div className="modal-body">
                <div className="address_holder">
                  <p className="type_text">
                    {" "}
                    <FontAwesomeIcon icon={faBuilding} className="inner_icon" />
                    Shipping Address
                  </p>

                  {allAddress?.data?.length > 0 && (
                    <p className="address_text">
                      {allAddress?.data[0]?.building},
                      {allAddress?.data[0]?.floor},
                      {allAddress?.data[0]?.apartment},
                      {allAddress?.data[0]?.street},
                      {allAddress?.data[0]?.direction},
                      {allAddress?.data[0]?.Users_Address_Detail?.City?.name},
                      {allAddress?.data[0]?.Users_Address_Detail?.State?.name},
                      {allAddress?.data[0]?.Users_Address_Detail?.Country?.name}
                      ,
                      {allAddress?.data[0]?.Users_Address_Detail?.Pincode?.name}
                      ,
                    </p>
                  )}

                   <p className="type_text">
                    {" "}
                    <FontAwesomeIcon icon={faBuilding} className="inner_icon" />
                    Billing Address
                  </p>

                  {allBillingAddress?.data?.length > 0 && (
                    <p className="address_text">
                      {allBillingAddress?.data[0]?.building},
                      {allBillingAddress?.data[0]?.floor},
                      {allBillingAddress?.data[0]?.apartment},
                      {allBillingAddress?.data[0]?.street},
                      {allBillingAddress?.data[0]?.direction},
                      {allBillingAddress?.data[0]?.Users_Address_Detail?.City?.name},
                      {allBillingAddress?.data[0]?.Users_Address_Detail?.State?.name},
                      {allBillingAddress?.data[0]?.Users_Address_Detail?.Country?.name}
                      ,
                      {allBillingAddress?.data[0]?.Users_Address_Detail?.Pincode?.name}
                      ,
                    </p>
                  )}

                  {allAddress?.data?.length > 0 && allBillingAddress?.data?.length > 0 ? (
                    <div className="btns_holder">
                      <Gray_Btn
                        btn_name="Update Address"
                        onClick={() => {
                          navigate("/saved-address");
                        }}
                      />
                      <Green_Btn
                        btn_name="Proceed"
                        onClick={() => {
                          navigate("/checkout");
                        }}
                      />
                    </div>
                  ) : (
                    <div className="btns_holder">
                      <Gray_Btn
                        btn_name="Add Address"
                        onClick={() => {
                          navigate("/saved-address");
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Login_Modal
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        loginDone={() => {
          setIsLogedIn(true);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showSetPassModal}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      />

      <Success_Modal
        show={showCouponModal}
        onHide={() => {
          setShowCouponModal(false);
        }}
        successText="Coupon applied successfully!"
      />

      <GST_modal
        GSTNumber={GSTNumber}
        setGSTNumber={setGSTNumber}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Payment_Summary;
